<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>                            
                        </router-link>
                        <button type="button" class="close" aria-label="Close" title="Conciliação bancária" style="padding-left: 10px; padding-right: 10px;" @click.prevent="mtdrotinaconciliacao()"><span aria-hidden="true"><i class="fa fa-bank"></i></span></button>                        
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo">
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Conta:</span>
                                <select id="cbcontapesq" data-placeholder="Selecione uma opção"
                                    v-model="pidconta" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvllancamentopesq">Valor lançamento:</label>
								<money type="text" class="form-control form-control-sm" id="edvllancamentopesq" v-model="pvllancamento" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Grupo de conta:</span>
                                <select id="cbgrupocontapesq" data-placeholder="Selecione uma opção"
                                    v-model="pidgrupoconta" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Plano de contas:</span>
                                <select id="cbplanocontapesq" data-placeholder="Selecione uma opção"
                                    v-model="pidplanoconta" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                    
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Centro de custo:</span>
                                <select id="cbcentrocustopesq" data-placeholder="Selecione uma opção"
                                    v-model="pidcentrocusto" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Provedor de custo:</span>
                                <select id="cbprovedorcustopesq" data-placeholder="Selecione uma opção"
                                    v-model="pidprovedorcusto" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Histórico padrão:</span>
                                <select id="cbhistoricopadraopesq" data-placeholder="Selecione uma opção"
                                    v-model="pidhistoricopadrao" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                                                                                      
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-md-2" style="padding-top: 25px;">
                                <div class="custom-control custom-switch" style="width: 100%; position: absolute; left:">
                                    <input type="checkbox" class="custom-control-input" id="swresumocontas" name="swresumocontas" v-model="presumocontas">
                                    <label class="custom-control-label" for="swresumocontas">Resumo das contas</label>
                                </div>						                                
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstlancamentos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        <span v-bind:class="parseInt(item.row.tipo) === 2 ? 'text-black-50 font-weight-bold' : ''">{{ mtdformatarzeros(item.row.id, 10) }}</span>
                                    </template>
                                    <template slot="slot_descricaolancamento" slot-scope="item">
                                        <span v-bind:class="parseInt(item.row.tipo) === 2 ? 'text-black-50 font-weight-bold' : ''">{{ item.row.descricaolancamento }}</span>
                                    </template>                                    
                                    <template slot="slot_entrada" slot-scope="item">
                                        <span v-if="parseInt(item.row.tipo) === 0" class="font-weight-bold" style="color: green;">{{ mtdformatavalordecimal(item.row.vllancamento, 2) }}</span>
                                        <span v-else> </span>
                                    </template>                               
                                    <template slot="slot_saida" slot-scope="item">
                                        <span v-if="parseInt(item.row.tipo) === 1" class="font-weight-bold" style="color: #f82b54;">{{ mtdformatavalordecimal(parseFloat(item.row.vllancamento), 2) }}</span>
                                        <span v-else> </span>
                                    </template>
                                    <template slot="slot_tipo" slot-scope="item">
                                        <span v-if="parseInt(item.row.tipo) === 0" class="badge badge-pill badge-success" style="background-color: #0acf97; font-size: 14px;"><i v-if="parseInt(item.row.transferencia) === 1" class="fa fa-info-circle" title="Transferência"></i> Entrada</span>
                                        <span v-else-if="parseInt(item.row.tipo) === 1" class="badge badge-pill badge-danger" style="background-color: #f82b54; font-size: 14px;"><i v-if="parseInt(item.row.transferencia) === 1" class="fa fa-info-circle" title="Transferência"></i> Saída</span>
                                        <span v-else class="badge badge-pill badge-secondary" style="font-size: 14px;">Transferência</span>
                                    </template>
                                    <template slot="slot_dtlancamento" slot-scope="item">
                                        <span v-bind:class="parseInt(item.row.tipo) === 2 ? 'text-black-50 font-weight-bold' : ''">{{ item.row.dtlancamento }}</span>
                                    </template>                                                                        
                                    <template slot="slot_conta" slot-scope="item">
                                        <span v-if="parseInt(item.row.tipo) === 2"> </span>
                                        <span v-else>{{ item.row.descricaoconta }}</span>
                                    </template>                                                                                                                                                     
                                    <template slot="slot_saldoconta" slot-scope="item">
                                        <template v-if="parseInt(item.row.tipo) < 2">
                                            <span v-if="parseFloat(item.row.saldoconta) >= 0" class="font-weight-bold" style="color: green;">{{ mtdformatavalordecimal(parseFloat(item.row.saldoconta), 2) }}</span>
                                            <span v-else class="font-weight-bold" style="color: #f82b54;">{{ mtdformatavalordecimal(parseFloat(item.row.saldoconta), 2) }}</span>
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-bold text-black-50">{{ mtdformatavalordecimal(parseFloat(item.row.vllancamento), 2) }}</span>
                                        </template>    
                                    </template>                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button v-if="parseInt(item.row.tipo) < 2" type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                        <button v-else type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluirtransf(item.row)"><i class="fa fa-trash"></i></button>                                        
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12" style="margin-bottom: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 5px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstlancamentos.length}}</span>
                                    </li>
                                </ul>
                            </div>
							<div class="col-md-12">
								<div class="row" v-show="lstlancamentos.length > 0">
									<div class="col-sm-12 col-md-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total Entradas <span class="badge badge-info" style="font-size: 12px;">{{ pqtdentradas }}</span>
												<span class="badge badge-primary bdg-totais" style="background-color: #0acf97;">{{ mtdformatavalordecimal(ptotalentradas, 2) }}</span></a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total Saídas <span class="badge badge-info" style="font-size: 12px;">{{ pqtdsaidas }}</span>
												<span class="badge badge-primary bdg-totais" style="background-color: #f82b54;">{{ mtdformatavalordecimal(ptotalsaidas, 2) }}</span></a>
										</ul>
									</div>                                    
									<div class="col-sm-12 col-md-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Diferença
												<span class="badge badge-primary bdg-totais" style="background-color: #7c7878;">{{ mtdformatavalordecimal(parseFloat(ptotalentradas) - parseFloat(ptotalsaidas), 2) }}</span></a>
										</ul>
									</div>                                    
                                </div>

                                <div class="row justify-content-center" style="margin-top: 10px;">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <ul class="list-group">
                                            <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">RESULTADOS</a>
                                            <a class="list-group-item list-group-item-action lstdetrec">Saldo anterior <span class="badge badge-secondary bdgtitulos">{{ mtdformatavalordecimal(psaldoanterior) }}</span></a>
                                            <a class="list-group-item list-group-item-action lstdetrec">Saldo atual (Saldo anterior + Dif) <span class="badge badge-info" style="font-size: 14px;">{{ pqtdentradas + pqtdsaidas}}</span><span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(psaldoanterior + (ptotalentradas - ptotalsaidas)) }}</span></a>
                                        </ul>
                                    </div>
                                </div>
                                <div v-show="presumocontas" class="row justify-content-center" style="margin-top: 10px;">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <ul class="list-group">
                                            <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">RESUMO DAS CONTAS</a>
                                            <a v-for="(conta, index) in lstcontas" v-bind:key="index" class="list-group-item list-group-item-action lstdetrec">{{mtdformatarzeros(conta.id, 2)}} - {{conta.descricao}} <span class="badge badge-secondary bdgtitulos">{{ mtdformatavalordecimal(conta.saldo) }}</span></a>

                                            <a v-if="psomacontas >= 0" class="list-group-item list-group-item-action lstdetrec">SOMA DAS CONTAS <span class="badge badge-success bdgtitulos" style="background-color: #0acf97;">{{ mtdformatavalordecimal(psomacontas) }}</span></a>

                                            <a v-else class="list-group-item list-group-item-action lstdetrec">SOMA DAS CONTAS <span class="badge badge-danger bdgtitulos" style="background-color: #f82b54;">{{ mtdformatavalordecimal(psomacontas) }}</span></a>         
                                        </ul>
                                    </div>
                                </div>

                            </div>                                    
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-4 col-sm-4 col-md-6 col-lg-6" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdimprimirlistagem()"><i class="fa fa-print"></i> Imprimir</button>
                            </div>                            
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdtransferencia()"><i class="fa fa-exchange"></i> Tranferências</button>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtlancamento">*Dt. Lançamento:</label>
								<div class="input-group">
									<date-picker id="eddtlancamento" v-model="vdtlancamento" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                            <div class="col-sm-12 col-md-5 col-lg-6">
                                <span class="lblselect2">*Conta:</span>
                                <select id="cbconta" data-placeholder="Selecione uma opção"
                                    v-model="vidconta" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edsaldoconta">Saldo:</label>
								<money type="text" class="form-control form-control-sm font-weight-bold" id="edsaldoconta" v-model="vsaldoconta" disabled v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>                                                                                                                
                            <div v-show="parseInt(vidtransferencia) === 0" class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">*Plano de contas:</span>
                                <select id="cbplanoconta" data-placeholder="Selecione uma opção"
                                    v-model="vidplanoconta" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div v-show="parseInt(vidtransferencia) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <label for="eddescricaogrupoconta">Grupo:</label>
                                <input type="text" class="form-control form-control-sm font-weight-bold" id="edid" v-model="vdescgrupo"
                                       maxlength="50" disabled/>
                            </div>
                            <div v-show="parseInt(vidtransferencia) === 0" class="col-sm-12 col-md-2 col-lg-2 text-center">
                                <span v-if="parseInt(vtipo) === 0" class="badge badge-pill badge-success bdg-tipo" style="background-color: #0acf97;">Entrada</span>
                                <span v-else-if="parseInt(vtipo) === 1" class="badge badge-pill badge-danger bdg-tipo" style="background-color: #f82b54;">Saída</span>                               
                                <span v-else-if="parseInt(vtipo) === 2" class="badge badge-pill badge-light bdg-tipo text-black-50">Transferência</span>                               
                                <span v-else></span>
                            </div>                                                                                    
                            <div v-show="parseInt(vidtransferencia) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Centro de custo:</span>
                                <select id="cbcentrocusto" data-placeholder="Selecione uma opção"
                                    v-model="vidcentrocusto" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div v-show="parseInt(vidtransferencia) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Provedor de custo:</span>
                                <select id="cbprovedorcusto" data-placeholder="Selecione uma opção"
                                    v-model="vidprovedorcusto" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div v-show="parseInt(vidtransferencia) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Histórico padrão:</span>
                                <select id="cbhistoricopadrao" data-placeholder="Selecione uma opção"
                                    v-model="vidhistoricopadrao" 
                                    data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                </select>
                            </div>                                                               
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <label for="eddescricaomovimento">*Descrição do movimento:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvalorlancamento">*Valor do lançamento:</label>
								<div class="input-group">
                                    <money type="text" class="form-control form-control-sm font-weight-bold" id="edvalorlancamento" v-model="vvalorlancamento" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; background: #0acf970f;" v-bind:disabled="ativadesativa"></money>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-dollar"></i></span>
									</div>										
								</div>                                								
							</div>                             
                            <div class="col-sm-12 col-md-12">
                                <label for="txtobservacoes">Observações:</label>
                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Transferência entre contas -->
        <div class="modal fade" id="mdtransferencia" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h4 class="modal-title" style="font-size: 14px;"><i class="fa fa-exchange"></i> Transferências entre contas</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="eddttransferencia">*Dt. Lançamento:</label>
								<div class="input-group">
									<date-picker id="eddttransferencia" v-model="tdttransferencia" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <span class="lblselect2">Conta Saída:</span>
                                <select id="cbcontasaidatransf" data-placeholder="Selecione uma opção"
                                    v-model="tidcontasaidatransf" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <span class="lblselect2">Conta Entrada:</span>
                                <select id="cbcontaentradatransf" data-placeholder="Selecione uma opção"
                                    v-model="tidcontaentradatransf" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-12 col-lg-12">
								<label for="edvalortransferencia">Valor da transferência:</label>
								<div class="input-group">
                                    <money type="text" class="form-control form-control-sm font-weight-bold" id="edvalortransferencia" v-model="tvalortransferencia" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; background: #0acf970f;"></money>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-dollar"></i></span>
									</div>										
								</div>                                								
							</div>
                            <div class="col-sm-12 col-md-12">
                                <label for="txtobservacoestransf">Observações:</label>
                                <textarea class="form-control center" rows="3" id="txtobservacoestransf" v-model="tobservacoestransferencia"></textarea>
                            </div>                                                                                                                                             
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmartransferencia()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div> 
        
        <!-- Modal Reconcilização bancária-->
        <div class="modal fade" id="mdconciliacao" tabindex="-1">
            <div class="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered">
                <div class="modal-content">            
                    <div class="modal-header">
                    <h4 class="modal-title">Conciliação bancária</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
                                <input type="file" id="btselecionaofx" accept=".ofx" style="display: none;">
                                <button type="button" @click.prevent="mtdarquivoofx()" class="btn btn-primary btn-sm btn-block" style="margin-top: 22px;">
                                    <i class="fa fa-file"></i> Selecionar arquivo
                                </button>
							</div> 
                            <div class="col-sm-12 col-md-6 col-lg-6 dvnomearquivoofx" style="margin-top: 22px;">
                                <h5 style="color: #757b81; font-size: 15px;">Arquivo: {{ vnomearquivoretorno }}</h5>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label>Dt. Inicio:</label>
                                <input type="text" v-bind:value="dtiniconciliar"
                                       class="form-control form-control-sm text-right" disabled>                                
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label>Dt. Fim:</label>
                                <input type="text" v-bind:value="dtfimconciliar"
                                       class="form-control form-control-sm text-right" disabled>                                                                
                            </div>                                                        
                        </div>
                        <div class="row" style="margin-top: 15px;">
							<div class="col-md-12 text-center" style="margin-bottom: 5px; margin-bottom: 5px; background: white;">
								<div class="col-md-12 border" style="border-radius: 5px;">
									<h6 style="margin: 5px;color: #666;" class="font-weight-bold">LANÇAMENTOS À CONCILIAR</h6>
								</div>
							</div>                            
							<div class="col-sm-12 table-responsive">
								<table class="table table-striped table-bordered table-sm table-hover" style="background: white;">
									<thead class="thead-dark">
										<tr>
											<th>Dt. movimento</th>
											<th>Descrição</th>
											<th>Valor</th>
                                            <th>Lançamento(s) relacionado(s)</th>
                                            <th>Perfil</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(movimento, ind) in lstlistconciliar" v-bind:key="ind">											
											<td class="text-right">{{ movimento.dtmovimento }}</td>
                                            <td>{{movimento.descricao}}</td>
											<td class="text-right font-weight-bold">
                                                <span v-if="parseFloat(movimento.valor) > 0" style="color: #0acf97;">{{ mtdformatavalordecimal(movimento.valor, 2) }}</span>
                                                <span v-else style="color: #f82b54;">{{ mtdformatavalordecimal(movimento.valor, 2) }}</span>
                                            </td>
                                            <td>
                                                <ul v-show="movimento.lancamentos.length > 0" class="list-group">
                                                    <li v-for="(lancamento, indexf) in movimento.lancamentos" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                        <span class="lblforma">{{lancamento.descricaolancamento}}</span>
                                                        <span class="lblforma">{{mtdformatavalordecimal(parseFloat(lancamento.vllancamento), 2)}}</span>
                                                    </li>
											    </ul>                                                
                                            </td>
                                            <td>
                                                <select class="form-control form-control-sm" v-model="movimento.idperfil">
                                                    <option value="-1"></option>
                                                    <option v-for="(perfil, ind) in mtdfiltraperil(movimento.tipo)" v-bind:key="ind" v-bind:value="perfil.id">{{ perfil.descricao }}</option>
                                                </select>                                                
                                            </td>                                            
										</tr>
									</tbody>
								</table>
							</div>                            
                        </div>
                    </div>                
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmarconciliacao()"><i class="fa fa-check"></i> Conciliar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"

    import util from '../utilitarios/util.js'

    export default {
        name: 'cadlancamentosfluxo',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                lstlancamentos: [],
                pfiltro       : 1,
                pconteudo     : '',
                pidfilial           : null,
                pidconta            : null,
                pvllancamento       : 0,
                pidgrupoconta       : null,
                pidplanoconta       : null,
                pidcentrocusto      : null,
                pidprovedorcusto    : null,
                pidhistoricopadrao  : null,
				pfiltroperiodo      : 1,
                hab_desab_periodo   : false,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),	                                                
                pqtdregistros : 99999999999,
                pqtd_paginas  : 1,
                pagina_atual  : 1,
                pqtd_total_registros: 0,
                presumocontas       : false,

                ptotalentradas      : 0,
                ptotalsaidas        : 0,
                pqtdentradas        : 0,
                pqtdsaidas          : 0,
                psaldoanterior      : 0,
                psomacontas         : 0,
                lstcontas           : [],                  

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vdtlancamento  		: util.DataAtual(true),
                vidconta            : null,
                vidgrupoconta       : null,
                vsaldoconta         : 0,
                vidplanoconta       : null,
                vdescgrupo          : '',
                vtipo               : '',
                vidcentrocusto      : null,
                vidprovedorcusto    : null,
                vidhistoricopadrao  : null,
                vdescricao          : '',
                vvalorlancamento    : 0,
                vobservacoes        : '',
                vidtransferencia    : 0,

                //variáveis transferência
                tdttransferencia 	 : util.DataAtual(true),
                tidcontaentradatransf: null,
                tidcontasaidatransf  : null,   
                tvalortransferencia  : 0,
                tobservacoestransferencia : '',

                //Conciliação bancária
                vnomearquivoretorno  : '',
                lstperfisfluxo       : [],              
                lstlistconciliar     : [],
                dtiniconciliar       : '',
                dtfimconciliar       : '',
                saldoconciliar       : 0,                                        

                //variável para habilitação dos campos
                ativadesativa        : true,
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },                
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'LANÇAMENTOS FLUXO DO CAIXA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado                        
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição do lançamento",
                        name: "descricaolancamento",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name : "slot_descricaolancamento"
                    },
                    {
                        label: "Entrada",
                        name: "vllancamento",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_entrada",
                    },
                    {
                        label: "Saída",
                        name: "vllancamento",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_saida",
                    },
                    {
                        label: "Tipo",
                        name: "tipo",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "slot_tipo",
                    },                    
                    {
                        label: "Dt. lançamento",
                        name: "dtlancamento",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name : "slot_dtlancamento"
                    },                    
                    {
                        label: "Conta",
                        name: "descricaoconta",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_conta"
                    },
                    {
                        label: "Saldo/Vl. Transf",
                        name: "saldoconta",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_saldoconta"
                    },                    
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdtemperfil(){
                let vself = this;
                let ret   = false;
                for (let i = 0; i < vself.lstlistconciliar.length; i++) {
                    if (parseInt(vself.lstlistconciliar[i].idperfil) !== -1){                        
                        return true;
                    }                    
                }
                return ret;
            },
            mtdfiltraperil(tipo){
                let lstpftmp = [];
                for (let i = 0; i < this.lstperfisfluxo.length; i++) {
                    if (parseInt(this.lstperfisfluxo[i].tipo) === parseInt(tipo)){
                        lstpftmp.push(this.lstperfisfluxo[i]);
                    }                    
                }
                return lstpftmp;
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtddefinicoesiniciais(){
                let vself = this;
                //let retm     = util.pri_ult_diames(new Date, true);
                //vself.pdtini = retm.primeirodiames;
                //vself.pdtfim = retm.ultimodiames;

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                
                                
                vself.pdtini = util.DataAtual(true);
                vself.pdtfim = util.DataAtual(true);                
				$('#mdtransferencia').on('shown.bs.modal', function (e) {
                    vself.tdttransferencia 	        = util.DataAtual(true);
                    vself.tvalortransferencia       = 0;
                    vself.tobservacoestransferencia = '';
                    $('#cbcontasaidatransf').val(null).trigger('change');
                    $('#cbcontaentradatransf').val(null).trigger('change');

					$('#eddttransferencia').focus();
				});                
                //select2 das pesquisar
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});                
                $("#cbcontapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidconta = $("#cbcontapesq").val();
                });  
                $("#cbgrupocontapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgruposcontas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidgrupoconta = $("#cbgrupocontapesq").val();
                });                                 
                $("#cbplanocontapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbplanosconta',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidplanoconta = $("#cbplanocontapesq").val();
                });                    
                $("#cbcentrocustopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcentroscustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidcentrocusto = $("#cbcentrocustopesq").val();
                });                
                $("#cbprovedorcustopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbprovedorescustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidprovedorcusto = $("#cbprovedorcustopesq").val();
                });
                $("#cbhistoricopadraopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbhistoricospadroes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidhistoricopadrao = $("#cbhistoricopadraopesq").val();
                });

                //select2 crud
                $("#cbconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidconta = $("#cbconta").val();
                    if (vself.vidconta !== null){
                        let loader      = vself.$loading.show();
                        let filtro      = ' and id='+vself.vidconta;
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : filtro},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadcontas.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.vsaldoconta = parseFloat(response.data[0].saldo);
                        }).catch(function (response) {
                            loader.hide();
                        });   
                    }else{
                        vself.vsaldoconta = 0;
                    }
                });                
                $("#cbplanoconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbplanosconta',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidplanoconta = $("#cbplanoconta").val();
                    if (vself.vidplanoconta !== null){
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'dadosplano'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'idplano',      valor : vself.vidplanoconta},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadgruposplanoscontas.php');
                        retorno.then(function (response) {
                            loader.hide();
                            //vself.vsaldoconta = parseFloat(response.data);
                            vself.vdescgrupo          = response.data.descgrupo;
                            vself.vtipo               = response.data.tipo;
                            vself.vidgrupoconta       = response.data.idgrupoconta;  

                            // vself.vidcentrocusto      = parseInt(response.data.idcentrocusto) === 0 ? null : response.data.idcentrocusto;                            
                            // if (vself.vidcentrocusto !== null){
                            //     var defcentro    = new Option(response.data.desccentrocusto, vself.vidcentrocusto, true, true);
                            //     $('#cbcentrocusto').append(defcentro).trigger('change');
                            // }else{
                            //     $('#cbcentrocusto').val(null).trigger('change');
                            // }

                            // vself.vidprovedorcusto    = parseInt(response.data.idprovedorcusto) === 0 ? null : response.data.idprovedorcusto;
                            // if (vself.vidprovedorcusto !== null){
                            //     var defprov    = new Option(response.data.descprovedorcusto, vself.vidprovedorcusto, true, true);
                            //     $('#cbprovedorcusto').append(defprov).trigger('change');
                            // }else{
                            //     $('#cbprovedorcusto').val(null).trigger('change');
                            // }
                            
                            // vself.vidhistoricopadrao  = parseInt(response.data.idhistoricopadrao) === 0 ? null : response.data.idhistoricopadrao;                                
                            // if (vself.vidhistoricopadrao !== null){
                            //     var defhist    = new Option(response.data.deschistoricopadrao, vself.vidhistoricopadrao, true, true);
                            //     $('#cbhistoricopadrao').append(defhist).trigger('change');                                
                            // }else{
                            //     $('#cbhistoricopadrao').val(null).trigger('change');    
                            // }

                        }).catch(function (response) {
                            loader.hide();
                        });   
                    }else{
                        vself.vdescgrupo          = '';
                        vself.vtipo               = '';
                        vself.vidgrupoconta       = null;
                        vself.vidcentrocusto      = null;
                        vself.vidprovedorcusto    = null;
                        vself.vidhistoricopadrao  = null;
                        $('#cbcentrocusto').val(null).trigger('change');
                        $('#cbprovedorcusto').val(null).trigger('change');
                        $('#cbhistoricopadrao').val(null).trigger('change');                        
                    }                    
                });                                
                $("#cbcentrocusto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcentroscustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcentrocusto = $("#cbcentrocusto").val();
                });
                $("#cbprovedorcusto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbprovedorescustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidprovedorcusto = $("#cbprovedorcusto").val();
                });                
                $("#cbhistoricopadrao").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbhistoricospadroes',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidhistoricopadrao = $("#cbhistoricopadrao").val();
                    if (vself.vidhistoricopadrao !== null){
                        if (vself.vdescricao === ''){
                            vself.vdescricao         = $("#cbhistoricopadrao").select2('data')[0]['text'];
                        }
                    }
                });                                
                //select2 transferência
                $("#cbcontaentradatransf").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.tidcontaentradatransf = $("#cbcontaentradatransf").val();
                });                
                $("#cbcontasaidatransf").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.tidcontasaidatransf = $("#cbcontasaidatransf").val();
                }); 
                $('#btselecionaofx').change(function() {
                    vself.mtdrotinaofx();
                });                                               
            },
            mtdfiltropesquisa(){
                let rfiltro     = '';
                let rfiltrosa   = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and l.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(l.descricaolancamento) like upper("'+this.pconteudo+'%")';
                }
                if (this.pidfilial !== null){
                    rfiltro = rfiltro + ' and cf.idfilial='+this.pidfilial;
				}                
                if (this.pidconta !== null){
                    rfiltro = rfiltro + ' and l.idconta='+this.pidconta;
				}
                if (parseFloat(this.pvllancamento) > 0){
                    rfiltro = rfiltro + ' and l.vllancamento='+this.pvllancamento;
                }
                if (this.pidgrupoconta !== null){
                    rfiltro = rfiltro + ' and l.idgrupoconta='+this.pidgrupoconta;
				}              
                if (this.pidplanoconta !== null){
                    rfiltro = rfiltro + ' and l.idplanoconta='+this.pidplanoconta;
				}
                if (this.pidcentrocusto !== null){
                    rfiltro = rfiltro + ' and l.idcentrocusto='+this.pidcentrocusto;
				}                
                if (this.pidprovedorcusto !== null){
                    rfiltro = rfiltro + ' and l.idprovedorcusto='+this.pidprovedorcusto;
				}   
                if (this.pidhistoricopadrao !== null){
                    rfiltro = rfiltro + ' and l.idhistoricopadrao='+this.pidhistoricopadrao;
				}

                rfiltrosa = rfiltro;                                                             

				if(parseInt(this.pfiltroperiodo) === 1){
                    rfiltro = rfiltro + ' and l.dtlancamento between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                }
                let refiltro = {
                    filtro   : rfiltro,
                    filtrosa : rfiltrosa
                }				                                        
                return refiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					util.notif("warning", 'Seu usuário precisa informar uma filial para consulta!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro.filtro},
                    {parametro: 'filtrosa',     valor  : filtro.filtrosa}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregalancamentos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregalancamentos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro.filtro},
                    {parametro: 'filtrosa',     valor : filtro.filtrosa},
                    {parametro: 'dtini',        valor : parseInt(this.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(this.pdtini)},                        
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                retorno.then(function (response) {
                    vself.lstlancamentos     = response.data.lancamentos;
                    vself.ptotalentradas     = parseFloat(response.data.totalentradas);
                    vself.ptotalsaidas       = parseFloat(response.data.totalsaidas);
                    vself.pqtdentradas       = parseInt(response.data.qtdentradas);
                    vself.pqtdsaidas         = parseInt(response.data.qtdsaidas);
                    vself.psaldoanterior     = parseFloat(response.data.saldoanterior);
                    vself.lstcontas          = response.data.contas;
                    vself.psomacontas        = 0;
                    for (var i = 0; i < vself.lstcontas.length; i++) {
                        vself.psomacontas = vself.psomacontas + parseFloat(vself.lstcontas[i]['saldo']);
                    }                        

                    loader.hide();
                }).catch(function (response) {
                    vself.lstlancamentos = [];
                    vself.ptotalentradas     = 0;
                    vself.ptotalsaidas       = 0;
                    vself.pqtdentradas       = 0;
                    vself.pqtdsaidas         = 0;
                    vself.psaldoanterior     = 0;                   
                    vself.lstcontas          = [];
                    vself.psomacontas        = 0;     
                    loader.hide();
                });
            },
            resetarDados() {
                let vself = this;
                util.toTop();

                vself.vid                 = '';
                vself.vdescricao          = '';
                vself.vdescgrupo          = '';
                vself.vdtlancamento  	  = util.DataAtual(true);
                vself.vtipo               = '';
                vself.vidconta            = null;
                vself.vsaldoconta         = 0;  
                vself.vidplanoconta       = null;  
                vself.vidcentrocusto      = null;
                vself.vidprovedorcusto    = null;
                vself.vidhistoricopadrao  = null;
                vself.vvalorlancamento    = 0;
                vself.vobservacoes        = '';
                vself.vidtransferencia    = 0;
                $('#cbconta').val(null).trigger('change');
                $('#cbplanoconta').val(null).trigger('change');
                $('#cbcentrocusto').val(null).trigger('change');
                $('#cbprovedorcusto').val(null).trigger('change');
                $('#cbhistoricopadrao').val(null).trigger('change');                                        

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {
                        $('#cbconta').select2('open');
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 200);
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('035Z.010Z.010Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE LANÇAMENTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstlancamentos         = [];
                this.pagina_atual           = 1;
                this.filtro                 = '';                
                this.pvllancamento          = 0;                                                                            
				this.pdtini       		    = util.DataAtual(true);
				this.pdtfim       		    = util.DataAtual(true);
                this.pqtd_total_registros   = 0;
                this.pqtd_paginas = 0;

                if (this.pidconta !== null){
                    this.pidconta               = null;
                    $('#cbcontapesq').val(null).trigger('change');
                }

                if (this.pidgrupoconta !== null){
                    this.pidgrupoconta          = null;
                    $('#cbgrupocontapesq').val(null).trigger('change');
                }

                if (this.pidplanoconta !== null){
                    this.pidplanoconta          = null;
                    $('#cbplanocontapesq').val(null).trigger('change');
                }

                if (this.pidcentrocusto !== null){
                    this.pidcentrocusto         = null;
                    $('#cbcentrocustopesq').val(null).trigger('change');
                }

                if (this.pidprovedorcusto !== null){
                    this.pidprovedorcusto       = null;
                    $('#cbprovedorcustopesq').val(null).trigger('change');
                }

                if (this.pidhistoricopadrao !== null){
                    this.pidhistoricopadrao     = null;
                    $('#cbhistoricopadraopesq').val(null).trigger('change');                  
                }
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and l.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.lancamentos[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#cbconta').select2('open');
                    }else{
                        if (parseInt(response.data.lancamentos[0].idtransferencia) > 0){
                            vself.$swal.fire({
                                                position: 'bottom-end',
                                                icon: 'info',
                                                //title: 'Atenção!',
                                                html: '<h6>Para a exclusão de transferências entre contas, os lançamentos relacionados de <strong>entradas/saídas</strong> também serão <strong>excluídos</strong>!</h6>',
                                                showConfirmButton: false,
                                                showCloseButton: true,
                                                backdrop: false                                                
                                            });
                    }                        
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (parseInt(item.transferencia) === 1){
                    util.notif("warning", 'Transferência não pode ser alterada!');
                    return;
                }
                if (!util.opcaousuario('035Z.010Z.020Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE LANÇAMENTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('035Z.010Z.030Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {                    
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE LANÇAMENTO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                let vself = this;
                vself.vid                 = registro.id;
                vself.vdtlancamento  	  = registro.dtlancamento;
                vself.vidgrupoconta       = registro.idgrupoconta;
                vself.vsaldoconta         = registro.saldoconta;                
                vself.vdescgrupo          = registro.descgrupo;
                vself.vtipo               = registro.tipo;
                vself.vdescricao          = registro.descricaolancamento;
                vself.vvalorlancamento    = registro.vllancamento;
                vself.vobservacoes        = registro.observacoes; 
                vself.vidtransferencia    = registro.idtransferencia;               

                vself.vidconta            = parseInt(registro.idconta) === 0 ? null : registro.idconta;                            
                if (vself.vidconta !== null){
                    var defconta    = new Option(registro.descricaoconta, vself.vidconta, true, true);
                    $('#cbconta').append(defconta).trigger('change');
                }else{
                    $('#cbconta').val(null).trigger('change');
                }

                vself.vidplanoconta       = registro.idplanoconta;
                if (vself.vidplanoconta !== null){
                    var defplanoconta    = new Option(registro.descricaoplanoconta, vself.vidplanoconta, true, true);
                    $('#cbplanoconta').append(defplanoconta).trigger('change');
                }else{
                    $('#cbplanoconta').val(null).trigger('change');
                }                

                setTimeout(() => {
                    vself.vidcentrocusto      = parseInt(registro.idcentrocusto) === 0 ? null : registro.idcentrocusto;                            
                    if (vself.vidcentrocusto !== null){
                        var defcentro    = new Option(registro.descricaocentrocusto, vself.vidcentrocusto, true, true);
                        $('#cbcentrocusto').append(defcentro).trigger('change');
                    }else{
                        $('#cbcentrocusto').val(null).trigger('change');
                    }

                    vself.vidprovedorcusto    = parseInt(registro.idprovedorcusto) === 0 ? null : registro.idprovedorcusto;
                    if (vself.vidprovedorcusto !== null){
                        var defprov    = new Option(registro.descricaoprovedorcusto, vself.vidprovedorcusto, true, true);
                        $('#cbprovedorcusto').append(defprov).trigger('change');
                    }else{
                        $('#cbprovedorcusto').val(null).trigger('change');
                    }
                    
                    vself.vidhistoricopadrao  = parseInt(registro.idhistoricopadrao) === 0 ? null : registro.idhistoricopadrao;                                
                    if (vself.vidhistoricopadrao !== null){
                        var defhist    = new Option(registro.descricaohistoricopadrao, vself.vidhistoricopadrao, true, true);
                        $('#cbhistoricopadrao').append(defhist).trigger('change');                                
                    }else{
                        $('#cbhistoricopadrao').val(null).trigger('change');    
                    }
                    vself.vtipo               = registro.tipo;                                        
                }, 300);
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                    : this.vid,
                    'dtlancamento'          : this.vdtlancamento,
                    'idconta'               : this.vidconta, 
                    'idgrupoconta'          : this.vidgrupoconta, 
                    'idplanoconta'          : this.vidplanoconta, 
                    'idcentrocusto'         : this.vidcentrocusto, 
                    'idhistoricopadrao'     : this.vidhistoricopadrao, 
                    'idprovedorcusto'       : this.vidprovedorcusto, 
                    'descricaolancamento'   : this.vdescricao, 
                    'observacoes'           : this.vobservacoes, 
                    'tipo'                  : this.vtipo, 
                    'vllancamento'          : this.vvalorlancamento,
                    'idtransferencia'       : this.vidtransferencia
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '035Z.010Z.010Z' : parseInt(this.opcrud) === 2 ? '035Z.010Z.020Z' : '035Z.010Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        vself.mtdlimpar_listagem();
                        vself.pfiltroperiodo= 0,
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : parseInt(vself.opcrud) === 2 ? vself.vid : '';
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregalancamentos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });
            },
            mtdtransferencia(){
                if (!util.opcaousuario('035Z.010Z.040Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    $('#mdtransferencia').modal('show');
                }
            },
            mtdconfirmartransferencia(){
                let vself = this;
                if (vself.tidcontasaidatransf === null){
                    util.notif("warning", 'Conta de saída deve ser informada!');
                    return;
                }                         
                if (vself.tidcontaentradatransf === null){
                    util.notif("warning", 'Conta de entrada deve ser informada!');
                    return;
                }                
                if (vself.tidcontaentradatransf === vself.tidcontasaidatransf){
                    util.notif("warning", 'Transferência não pode ser feita para mesma conta!');
                    return;
                }
                if (vself.tdttransferencia === null || vself.tdttransferencia === ''){
                    util.notif("warning", 'Data de transferência inválida!');
                    return;
                }
                if (vself.tvalortransferencia <= 0){
                    util.notif("warning", 'Informe o valor válido para a transferência!');
                    return;
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma transferência entre as contas?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Cancelar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        let loader = vself.$loading.show();
                                let registrocrud = {
                                    'id'                    : 0,
                                    'dtlancamento'          : vself.tdttransferencia,
                                    'idconta'               : vself.tidcontasaidatransf, 
                                    'idgrupoconta'          : 9999, 
                                    'idplanoconta'          : '9999', 
                                    'idcentrocusto'         : 9999, 
                                    'idhistoricopadrao'     : 9999, 
                                    'idprovedorcusto'       : 9999, 
                                    'descricaolancamentosaida'      : $('#cbcontasaidatransf').select2('data')[0]['text']+' -> '+$('#cbcontaentradatransf').select2('data')[0]['text'], 
                                    'descricaolancamentoentrada'    : $('#cbcontaentradatransf').select2('data')[0]['text']+' -> '+$('#cbcontasaidatransf').select2('data')[0]['text'], 
                                    'observacoes'           : vself.tobservacoestransferencia, 
                                    'tipo'                  : 2, 
                                    'vllancamento'          : vself.tvalortransferencia,
                                    'idcontaentrada'        : vself.tidcontaentradatransf
                                };
                                let parametros      = [
                                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'transferencia'},
                                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                    {parametro: 'codop',        valor : '035Z.010Z.040Z'},
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if ($.isNumeric(response.data)){
                                        util.notif("success", 'Registro processado com sucesso!')
                                        vself.mtdlimpar_listagem();
                                        vself.pfiltroperiodo= 0,
                                        vself.pfiltro       = 0;
                                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                                        vself.pqtd_paginas  = 1;
                                        vself.mtdcancelaredicao();
                                        vself.mtdcarregalancamentos(1);
                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                util.notif("warning", response.data.substring(4))
                                                break;
                                            case 'E': default:
                                                util.notif("error", response.data.substring(4))
                                                break;
                                        }
                                    }
                                    $('#mdtransferencia').modal('hide');
                                }).catch(function (response) {                                    
                                    loader.hide();
                                    $('#mdtransferencia').modal('hide');
                                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                                });       
                    } else {
                        $('#btgravar').focus();
                    }
                });                                       
            },
            mtdexcluirtransf(item){
                let vself = this;
                if (!util.opcaousuario('035Z.010Z.030Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {     
                    
                    Swal.fire({
                        customClass: {
                            confirmButton: "btn btn-success conf",
                            cancelButton: "btn btn-danger"
                        },
                        title: "Confirmação",
                        text: 'Confirma EXCLUSÃO da transferência?',
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Cancelar"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.conf').prop('disabled', true);
                            let loader = vself.$loading.show();
                            let registrocrud = {
                                'id'                    : item.id,
                                'dtlancamento'          : item.dtlancamento,
                                'idconta'               : item.idconta, 
                                'idgrupoconta'          : item.idgrupoconta, 
                                'idplanoconta'          : item.idplanoconta, 
                                'idcentrocusto'         : item.idcentrocusto, 
                                'idhistoricopadrao'     : item.idhistoricopadrao, 
                                'idprovedorcusto'       : item.idprovedorcusto, 
                                'descricaolancamento'   : item.descricaolancamento, 
                                'observacoes'           : item.observacoes, 
                                'tipo'                  : item.tipo, 
                                'vllancamento'          : item.vllancamento,
                                'idcontaentrada'        : item.idcontaentrada
                            };
                            let parametros      = [
                                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                {parametro: 'op',           valor : 'rotinacrud'},
                                {parametro: 'opcrud',       valor : 3},
                                {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                                {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                {parametro: 'codop',        valor : '035Z.010Z.030Z'},
                            ];
                            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                            retorno.then(function (response) {
                                loader.hide();
                                if ($.isNumeric(response.data)){
                                    util.notif("success", 'Registro processado com sucesso!')
                                    vself.mtdlimpar_listagem();
                                    vself.pfiltroperiodo= 0,
                                    vself.pfiltro       = 0;
                                    vself.pconteudo     = '';
                                    vself.pqtd_paginas  = 1;
                                    vself.mtdcancelaredicao();
                                    vself.mtdcarregalancamentos(1);
                                }else{
                                    let tpret = response.data.substring(0,1);
                                    switch (tpret) {
                                        case 'I':
                                            util.notif("warning", response.data.substring(4))
                                            break;
                                        case 'E': default:
                                            util.notif("error", response.data.substring(4))
                                            break;
                                    }
                                }
                            }).catch(function (response) {                                    
                                loader.hide();
                                util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                            });
                        } else {
                            $('#btgravar').focus();
                        }
                    }); 
                              
                }        
            },
            mtdarquivoofx() {
                const file               = document.querySelector('#btselecionaofx');
                file.value               = '';
                this.vnomearquivoretorno = '';
                ///////////////////////////////
                $('#btselecionaofx').trigger('click');
            },
            mtdrotinaofx(){
                let vself = this;                
                
                let varquivoofx         = document.getElementById("btselecionaofx").files[0];
                vself.vnomearquivoretorno = varquivoofx.name;

                let extarq = varquivoofx.name.substring(varquivoofx.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'OFX'){
                    util.notif("warning", "O arquivo de retorno selecionado não é um arquivo válido!");

                }else{ 
                    let loader      = vself.$loading.show();
                    let localsalvar = vself.$store.state.configpaths.pathofx + vself.$store.state.filialpadrao.idcliente;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : varquivoofx},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : vself.vnomearquivoretorno}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            $('#btselecionaofx').val('');
                            vself.mtdprocessararquivo(vself.$store.state.configpaths.pathofx + vself.$store.state.filialpadrao.idcliente+'/'+vself.vnomearquivoretorno)
                        }else{
                            $('#btselecionaofx').val('');
                            util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.data);
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                        $('#btselecionaofx').val('');
                    });
                }
            },
            mtdprocessararquivo(arquivo){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processararquivoofx'},
                    {parametro: 'arquivo',      valor : arquivo}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.status)){
                        vself.lstperfisfluxo    = response.data.perfis;
                        vself.lstlistconciliar  = response.data.lancamentos;
                        vself.dtiniconciliar    = response.data.datainicio;
                        vself.dtfimconciliar    = response.data.datafim;
                        vself.saldoconciliar    = response.data.saldoconta;
                    }else{
                        util.notif("error", "impossivel processar o arquivo")                      
                        console.log(response.data);
                        vself.lstperfisfluxo    = [];                        
                        vself.lstlistconciliar  = [];                        
                        vself.dtiniconciliar    = '';
                        vself.dtfimconciliar    = '';
                        vself.saldoconciliar    = 0;                        
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });                
            },                                    
            mtdrotinaconciliacao(){                
                if (!util.opcaousuario('035Z.010Z.050Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {                
                    this.vnomearquivoretorno = '';
                    this.lstperfisfluxo      = [];              
                    this.lstlistconciliar    = [];
                    this.dtiniconciliar      = '';
                    this.dtfimconciliar      = '';
                    this.saldoconciliar      = 0;
                    $('#mdconciliacao').modal('show');
                }
            },
            mtdconfirmarconciliacao(){
                let vself = this;
                if (vself.mtdtemperfil()){
                    Swal.fire({
                        customClass: {
                            confirmButton: "btn btn-success conf",
                            cancelButton: "btn btn-danger"
                        },
                        title: "Confirmação",
                        text: 'Confirma conciliação bancária?',
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Cancelar"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.conf').prop('disabled', true);
                            vself.mtdgravarconciliacao();
                        } else {
                            $('#btgravar').focus();
                        }
                    });
             
                }else{
                    util.notif("warning", 'Defina ao menos um perfil do fluxo para a conciliação!');                    
                }
            },
            mtdgravarconciliacao(){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'conciliarmovimentos'},
                    {parametro: 'lancamentos',  valor : JSON.stringify(vself.lstlistconciliar)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '035Z.010Z.050Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadlancamentosfluxo.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        $('#mdconciliacao').modal('hide');                
                        vself.mtdlimpar_listagem();
                        vself.pvllancamento       = 0;
                        vself.pidgrupoconta       = null;
                        vself.pidplanoconta       = null;
                        vself.pidcentrocusto      = null;
                        vself.pidprovedorcusto    = null;
                        vself.pidhistoricopadrao  = null;
                        vself.pfiltroperiodo= 1,
                        vself.pqtdregistros = '99999999999';
                        vself.pdtini        = vself.dtiniconciliar;
                        vself.pdtfim        = vself.dtfimconciliar;
                        vself.pfiltro       = 0;
                        vself.pconteudo     = '';
                        vself.pqtd_paginas  = 1;

                        vself.mtdcancelaredicao();
                        vself.mtdexecutapesquisa();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });                
            },
            mtdimprimirlistagem(){
                let vself   = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
                    util.notif("warning", 'Seu usuário deve informar a filial para realização da consulta!');
					return;
				}                
                let filtro  = vself.mtdfiltropesquisa();
                let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let src     = vself.presumocontas ? '1' : '0';
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadlancamentosfluxo.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro.filtro+
                            '&filtrosa='+filtro.filtrosa+
                            '&dtini='+dtini+
                            '&dtfim='+dtfim+
                            '&rc='+src+
                            '&filial='+filial+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            }            
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('035Z.010Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinicoesiniciais();
                        vself.mtdcarregalancamentos(vself.pagina_atual);
                    } else {
                        util.notif("warning", 'Acesso não permitido para o usuário!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
			selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },            
            validou() {
                return this.vdescricao === '' || this.vidconta === null || this.vdtlancamento === null || this.vdtlancamento === '' ||
                       this.vidplanoconta === null || this.vidcentrocusto === null || this.vidprovedorcusto === null ||
                       this.vidhistoricopadrao === null || this.vvalorlancamento <= 0;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregalancamentos(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .bdg-tipo{
        border-radius: 5px;
        font-size: 14px!important;
        padding: 10px!important;
        margin-top: 18px!important;
        width: 100%;        
    }
    .dvnomearquivoofx{
        border: 1px solid #ced4da;
        padding-top: 5px;
        height: 30px;
        border-radius: 4px;
        /* margin-left: 15px;
        margin-right: 15px; */
    }    
</style>